import * as React from 'react';
import { FC } from 'react';
import * as ReactDOM from 'react-dom';

interface IReactPortalProps {
    className?: string[];
    el?: string;
}

export const ReactPortal: FC<IReactPortalProps> = ({ children, className = ['srw', 'starryui-modal'], el = 'div' }) => {
    const [container] = React.useState(() => {
        return document.createElement(el);
    });

    React.useEffect(() => {
        container.classList.add(...className);
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, []);

    return ReactDOM.createPortal(children, container);
};
